import spinnerLoader from './reducer';

export default spinnerLoader;
